import React from 'react';
import { Form } from 'react-bootstrap';
import CurrencyFormat from 'react-currency-format';
import InputMoney from './InputMoney';

const Control = props => <Form.Control {...props} />;

const Currency = props => (
  <InputMoney
    // customInput={Control}
    // thousandSeparator="."
    // decimalSeparator=","
    // prefix="R$ "
    // maxLength={15}
    // max="999999999.99"
    // fixedDecimalScale={true}
    // decimalScale={2}
    {...props}
  />
);

const DollarCurrency = props => (
  <CurrencyFormat
    customInput={Control}
    thousandSeparator="."
    decimalSeparator=","
    prefix="$ "
    maxLength={17}
    max="999999999.99"
    fixedDecimalScale={true}
    decimalScale={2}
    {...props}
  />
);

const EuroCurrency = props => (
  <CurrencyFormat
    customInput={Control}
    thousandSeparator="."
    decimalSeparator=","
    prefix="€ "
    maxLength={17}
    max="999999999.99"
    fixedDecimalScale={true}
    decimalScale={2}
    {...props}
  />
);

const currencyReverse = currency => {
  if (typeof currency === 'number') return currency;

  return parseFloat(
    currency
      .replace(/\./g, '')
      .replace(',', '.')
      .replace(/[^0-9\.]+/g, '')
  );
};

const CurrencyPlainText = props => (
  <Currency
    plaintext
    readOnly
    style={{ padding: '0px' }}
    tabIndex="-1"
    {...props}
  />
);

const CurrencyEuroPlainText = props => (
  <EuroCurrency
    plaintext
    readOnly
    style={{ padding: '0px' }}
    tabIndex="-1"
    {...props}
  />
);

const CurrencyDollarPlainText = props => (
  <DollarCurrency
    plaintext
    readOnly
    style={{ padding: '0px' }}
    tabIndex="-1"
    {...props}
  />
);

const formatMoney = (value, currency = 'BRL', locale = 'pt-br') => {
  if(!value){
    value = 0;
  }
  return new Intl.NumberFormat(
    locale, 
    { 
      style: 'currency',
      currency
    }
  ).format(value)
}

export {
  currencyReverse,
  CurrencyPlainText,
  Currency,
  DollarCurrency,
  EuroCurrency,
  CurrencyDollarPlainText,
  CurrencyEuroPlainText,
  formatMoney
};

export default Currency;
